<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">Infrastructure</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <ul class="sub-menu">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/campus-buildings">Campus Buildings</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/library">Library</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/labs">Labs</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/play-ground">Play Ground</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/hostel">Hostel</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/events">Events</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/sports">Sports</a></li>        
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/transport-and-parking">Transport &amp; Parking</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/infra/any-others">Any Others</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
